import { DataType, DrawerProps } from "./types";
import { useContext, useEffect, useState } from "react";
import { DrawerContext } from "../../../contexts/drawer/index.context";
import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import { FormContext } from "../../../contexts/form/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";
import styles from "./styles.module.scss";

import { TableContext } from "../../../contexts/table/index.context";
//UI
import Space from "antd/lib/space";
import Spin from "antd/lib/spin";
import Table from "antd/lib/table";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
import Drawer from "antd/lib/drawer";

//Icons
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import { BookOutlined, PlusOutlined } from "@ant-design/icons";

/**
 * DrawerComponent is a reusable component that provides a drawer interface
 * Компонент керування модальним вікном таблиць
 * @param props
 * @returns
 */

export default function DrawerComponent(props: DrawerProps) {
  const hiddne = props.hidden || false;
  const newIcon = props.newIco || false;
  // console.log("PROPS DRAWERCOMPONENT ", props);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState<DataType | any>(
    props.name /* undefined */
  );
  // console.log("PROPS DRAWERCOMPONENT setContent ", content);

  // const [data, setData] = useState(undefined);
  // const [loading, setLoading] = useState(false);
  // const [disabled, setDisabled] = useState(true);
  // const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);
  const { boxStr, setBoxStr } = useContext(TableContext);
  const drawerContext = useContext(DrawerContext);
  const { contentContext, setContentContext} = useContext(DrawerContext);
  const { form } = useContext(FormContext);
  // console.log("PROPS DRAWERCOMPONENT FormContext ", FormContext);

  const { intl } = useContext(TranslationContext);
    // console.log("dddacv content", content);

  // useEffect(() => {
  //   if (props.url && rowData[props.url]) {
  //     setContent(rowData[props.url].name);
  //   }
  // }, [props.url, rowData]);

  const showDrawer = () => {
    drawerContext.showDrawer();
    setOpen(true);
  };

  const onClose = () => {
    onClearBoxStrContent();
    // onClearSessionData();
    drawerContext.onClose(); 
    setOpen(false);
  };

  const onOk = () => {
    onClearBoxStrContent();
    setOpen(false);
    props.setFormFields?.();
    // console.log("props.name2", props.name2);
    setContent(props.name2);
    setContentContext(props.name2);
  };

  const onClearContent = () => {
    // console.log("props.fieldName 1", props.fieldName);

    setContent(undefined);
    setContentContext(undefined);

    // if (props.fieldName) {
    //   console.log("props IF ", props.fieldName);
    //   form.setFieldsValue({
    //     [props.fieldName]: undefined,
    //     [`${props.fieldName}_ID`]: undefined,
    //     [`${props.fieldName}_id`]: undefined, // якщо ключ id окремо, як PROF_id
    //   });
    // }
    props.fieldName && form.setFieldsValue({ [props.fieldName]: [] });
    // console.log("fieldsValue value", form.getFieldsValue());

  };
  /** Function to clear the content of the boxStr based on the current URL.*/
  const onClearBoxStrContent = () => {
    props?.url && setBoxStr(boxStr?.filter((item) => item.url !== props?.url));
  };

  const onClearSessionData = () => {
    // if (!props?.url) return;
    // Object.keys(sessionStorage).forEach((key) => {
    //   if (key.startsWith(`session_data_${props?.url}`) || key.startsWith(`table_state_${props?.url}`)) {
    //     sessionStorage.removeItem(key);
    //   }
    // });
  };
  // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setContent(event.target.value);
  //   props.onRowClick?.(event.target.value);
  // };

  // const onClickRow = (record: any) => {
  //   setContent(record.Name);
  //   setDisabled(false);
  //   props.onRowClick(record.id);
  // };

  return (
    <Space className={styles["space"]} size={4}>
      {!hiddne ?
        <Input
          className={styles["input"]}
          value={content}
          // onChange={handleInputChange}
          disabled={props.inputDisabled ?? true}
        />
        : null
      }

      {!hiddne ?
        <Button
        // className={styles["button-outline"]}
          icon={<EllipsisOutlined />}
          onClick={showDrawer /* () => drawerContext.showDrawer() */}
          disabled={props.disabled}
        /> 
        :
        <div className={styles[newIcon ? "btnAddDrawer" : "btnAddDrawerNoBorder"]} onClick={showDrawer}>{newIcon ? <BookOutlined /> : <PlusOutlined />}</div>
      }
      {!hiddne ?
        <Button
        className={styles["button-outline"]}
          icon={<CloseOutlined />}
          onClick={onClearContent}
          disabled={props.disabled}
        /> : null
      }
      <Drawer
        className={styles["drawer"]}
        placement="top"
        onClose={onClose /* () => drawerContext.onClose() */}
        open={/* drawerContext.open || */ open}
        closable={false}
        footer={
          <Space>
            <Button
              onClick={
                onClose /* () => {
                  drawerContext.onClose();
                  // props.onRowClick(null);
                } */
              }
            >
              {intl("cancel")}
            </Button>
            <Button
              className={styles["button"]}
              type="primary"
              onClick={
                onOk /* () => {
                  // setContent(props.inputValue);
                  drawerContext.onClose();
                } */
              }
              // disabled={/* disabled */ props.disabled}
            >
              {intl("ok")}
            </Button>
          </Space>
        }
      >
        {props.children}
      </Drawer>
    </Space>
  );
}
